import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useLeaveQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useLeaveQuery = (id) =>
        useQuery({
            queryKey: ["leave", id],
            queryFn: ({ queryKey }) => {
                const [, leaveId] = queryKey;
                return axiosPrivate
                    .get(`leave/${leaveId}/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    // GET all leaves (default list)
    const leaveListQuery = useQuery({
        queryKey: ["leave", "list"],
        queryFn: () =>
            axiosPrivate
                .get("leave/")
                .then(r => r.data),
    });

    // GET leaves for business
    const leaveListForBusinessQuery = useQuery({
        queryKey: ["leave", "business"],
        queryFn: () =>
            axiosPrivate
                .get("leave/get_for_business/")
                .then(r => r.data),
    });

    // GET leaves for colleague
    const useLeaveListForColleagueQuery = (colleagueId) =>
        useQuery({
            queryKey: ["leave", "colleague", colleagueId],
            queryFn: ({ queryKey }) => {
                const [, , id] = queryKey;
                return axiosPrivate
                    .get(`leave/${id}/get_for_colleague/`)
                    .then(r => r.data);
            },
            enabled: !!colleagueId,
        });

    // MUTATIONS ------------------------------------------------------

    const createLeaveMutation = useMutation({
        mutationFn: (data) =>
            axiosPrivate.post("leave/", data).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["leave"]);
        },
    });

    const updateLeaveMutation = useMutation({
        mutationFn: ({ id, data }) =>
            axiosPrivate.patch(`leave/${id}/`, data).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["leave"]);
        },
    });

    const deleteLeaveMutation = useMutation({
        mutationFn: (id) =>
            axiosPrivate.delete(`leave/${id}/`).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["leave"]);
        },
    });

    return {
        // queries
        useLeaveQuery,
        leaveListQuery,
        leaveListForBusinessQuery,
        useLeaveListForColleagueQuery,

        // mutations
        createLeaveMutation,
        updateLeaveMutation,
        deleteLeaveMutation,
    };
}
